import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import LexwareConnectButton from "./LexwareConnectButton";

const IntegrationItemActions = ({ item, editValue, onEditChange, onUpdate, t }) => {
  
  // CASE 1: Lexware (OAuth)
  if (item.provider === "lexware_office") {
    return (
      <div className="actions-oauth">
        <LexwareConnectButton text="Reconnect" />
      </div>
    );
  }

  // CASE 2: WISO
  if (item.provider === "wiso") {
    return <span style={{ fontSize: "12px", color: "#1976d2" }}>Extension active</span>;
  }

  // CASE 3: Standard (API Key)
  return (
    <div style={{ display: "flex", gap: "8px", flex: 1 }}>
      <input
        type="password"
        placeholder="********"
        className="integration-input"
        value={editValue || ""}
        onChange={(e) => onEditChange(e.target.value)}
      />
      <button className="save-btn" onClick={() => onUpdate(item.provider)}>
        <SaveIcon fontSize="small" />
      </button>
    </div>
  );
};

export default IntegrationItemActions;